import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-materiel",
  "use": "icon-materiel-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-materiel\"><path d=\"M934.912 240.64L523.264 0l-409.6 239.616 410.624 237.568zM551.936 1013.76l409.6-239.616V295.936L551.936 532.48zM84.992 294.912v479.232l409.6 239.616V531.456l-409.6-236.544z m290.816 345.088l-194.56-111.616c-3.072-2.048-6.144-6.144-6.144-10.24v-64.512c0-9.216 9.216-14.336 17.408-10.24l194.56 111.616c3.072 2.048 6.144 6.144 6.144 10.24v64.512c0 9.216-9.216 14.336-17.408 10.24z\" p-id=\"5642\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/materiel.svg
// module id = 8lbs
// module chunks = 241